<template>
  <div class="ideas-block">
    <div class="container">
      <TitleWithLines
        v-if="data.title"
        :title="data.title"
      />

      <div class="ideas-block__sections">
        <Section
          v-for="(item, index) in data.sections"
          v-show="item.subsections.length > 0"
          :key="index"
          :index="index + 1"
          :title="item.title"
          :description="item.shortDescription"
          :subsections="item.subsections"
        />
      </div>

      <div v-if="data.description" class="ideas-block__description" v-html="data.description" />
    </div>
  </div>
</template>

<script>
  import TitleWithLines from '@/components/shared/TitleWithLines'
  import Section from '@/components/shared/Section'
  export default {
    name: 'IdeasBlock',

    components: { TitleWithLines, Section },

    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },


    mounted () {
      // console.log(this.data.sections[0])
      console.log(this.data)
    },

    methods: {
    }

  }
</script>

<style lang="scss">
.ideas-block {
  padding: 192px 0 50px;
  width: 100%;
  max-width: 1129px;
  margin: 0 auto;
  overflow: hidden;

  @include tablet {
    padding-top: 96px;
    padding-bottom: 0;
  }

  @include mobile {
    padding-bottom: 0;
  }

  .title-with-lines {
    margin-left: auto;
    width: 100%;
    max-width: 1000px;
    text-align: center;
    padding-left: 300px;
    margin-bottom: 73px;

    @include tablet {
      padding-left: 150px;
    }

     @include mobile {
      padding: 0;
      margin-bottom: 48px;
    }
  }

  .title-with-lines__title {
    margin-left: auto;
    margin-right: 200px;

    @include mobile {
      text-align: left;
      margin-left: 15%;
    }
  }

  &__description {
    font-size: 18px;
    line-height: 1.34;
    margin-bottom: 50px;
    margin-top: 64px;
    color: $c-light-black;

    @include tablet {
      margin-top: 40px;
      margin-bottom: 0;
    }

    @include mobile {
      font-size: 16px;
      margin-top: 30px;
    }
  }
}
</style>
